module.exports = __webpack_public_path__ + "static/media/DSC_0068.fb464f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0068.jpg
// module id = 552
// module chunks = 0